import { MenuItem, TextField, Typography } from "@mui/material";

import { PanelSection } from "../PanelSection/PanelSection";
import { NO_CLIP } from "../../../viewerConstants";

interface AnimationControlsProps {
  clipNames: string[];
  playingClip: string | null;
  onPlayClip: (clipName: string | null) => void;
}

export function AnimationControls({ clipNames, playingClip, onPlayClip }: AnimationControlsProps) {
  return (
    <PanelSection title="Animation">
      {clipNames.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          No animation clips.
        </Typography>
      ) : (
        <TextField
          select
          size="small"
          label="Clip"
          value={playingClip ?? NO_CLIP}
          onChange={(event) => onPlayClip(event.target.value || null)}
          data-testid="viewer-clip"
        >
          <MenuItem value={NO_CLIP}>None</MenuItem>
          {clipNames.map((name) => (
            <MenuItem key={name} value={name}>
              {name}
            </MenuItem>
          ))}
        </TextField>
      )}
    </PanelSection>
  );
}
